import React, { Fragment, useState } from "react";
import OptimizerComponent from "../../CommonUtils/SelectChannelsAndPacks/OptimizerComponent/OptimizerComponent";

export default function MessageA61(props) {
  const { code,text_data } = props.item;

 
  const { tag, handleClick } = props;
  const [apllied, setApplied] = useState(false);
  const handleFilterApplied = (data) => {
    setApplied(data);
  };

  const onSubmitHandler = (code, data, tag) => {
    props.addMessages(data, '7.1111111.11.111.121.10',null,null,null, "A61");
  };
  return (
    <OptimizerComponent
      {...props}
      filterToggle={(data) => {
        handleFilterApplied(data);
      }}
      onClickSubmit={(code, data, tag) => {
        onSubmitHandler(code, data, tag);
      }}
      data={text_data}
      code={code}
      tag={tag}
    />
  );
}
